<vc-catalog
  [page]="page"
  [pageType]="'catalog'"
  [config]="configCatalog"
  [breadcrumb]="breadcrumb"
  [searchParameters]="searchParameters"
  [likedItem]="likedItem"
  [facetLink]="facetLink"
  [isFirstPage]="isFirstPage"
  [searchStore]="searchStore"
  [currentCountry]="currentCountry"
  [campaign]="campaign"
  [seoLinks]="seoLinks"
  [seoContents]="seoContents"
  [marketingFilter]="marketingFilter"
>
</vc-catalog>
